export default function addLineBreaks(text: string) {
  return text?.replace(/\n/gi, "  \n");
}
